export default __webpack_public_path__ + "static/media/basket.f662d802.png";